module.exports = __webpack_public_path__ + "static/media/boyy.f827dfb6.png";